import ENVIRONMENT_VARIABLES from './environmentVariables';
var application = ENVIRONMENT_VARIABLES.APPLICATION_TARGET;
export var isTi = application === 'ti';
export var isHri = application === 'hri';
export var isSga = application === 'sga';
export var isMillelacs = application === 'millelacs';
export var isJamul = application === 'jamul';
export var isLadyluck = application === 'ladyluck';